import {
  ApolloQueryResult,
  FetchMoreQueryOptions,
  QueryResult,
} from '@apollo/client';

import { Empty } from 'apps/dashboard/shared/scripts/components';
import { PaginationInput } from 'apps/shared/scripts/__generated__/graphql.generated';
import { InfiniteLoader } from 'apps/shared/scripts/components';
import { SimpleCardFragment } from 'apps/shared/scripts/graphql/fragments/CardFragment.generated';
import { SignatureFragment } from 'apps/shared/scripts/graphql/fragments/SignatureFragment.generated';

import SignatureItem from './SignatureItem';
import { signaturesListClassName } from './styles';

interface Props {
  signatures: SignatureFragment[];
  cursor: string;
  fetchMore: (
    options: FetchMoreQueryOptions<PaginationInput>,
  ) => Promise<ApolloQueryResult<QueryResult<SimpleCardFragment>>>;
  hasNextPage: boolean;
}

const SignaturesList = ({
  signatures,
  cursor,
  fetchMore,
  hasNextPage,
}: Props) => {
  const list = signatures.map((signature, i) => (
    <SignatureItem key={i} {...signature} />
  ));

  if (!list.length) {
    return <Empty description="No Cards Signed" />;
  }

  return (
    <>
      <div className={signaturesListClassName}>{list}</div>
      <InfiniteLoader
        cursor={cursor}
        fetchMore={fetchMore}
        hasNextPage={hasNextPage}
      />
    </>
  );
};

SignaturesList.displayName = 'SignaturesList';

export default SignaturesList;
